import { render, staticRenderFns } from "./UserList1.vue?vue&type=template&id=49d4d33a&scoped=true&"
import script from "./UserList1.vue?vue&type=script&lang=js&"
export * from "./UserList1.vue?vue&type=script&lang=js&"
import style0 from "./UserList1.vue?vue&type=style&index=0&id=49d4d33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4d33a",
  null
  
)

export default component.exports